<lib-assistance
  [labels]="'lib.assistance' | translate"
  [theme]="theme"
  [buttonLabel]="'homePage.assistance.buttonLabel' | translate"
  [title]="'homePage.assistance.title' | translate"
  [text]="'homePage.assistance.text' | translate"
  [title1]="'homePage.assistance.title1' | translate"
  [title2]="'homePage.assistance.title2' | translate"
  [buttonLabel2]="'homePage.assistance.buttonLabel2' | translate"
  [assistanceImg]="'assets/images/WU_assistance.jpg'"
  [imgText]="'homePage.assistance.imgText' | translate"
  [titlefontsize]="'5xl'"
  (firstButtonClicked)="navigateToContacts()"
  (secondButtonClicked)="navigateTostores()"
></lib-assistance>
